// removed by extract-text-webpack-plugin
module.exports = {"ba-modal":"magazines_X4Bhp","ba-subtitle":"magazines_2KdNN","ba-modal-card":"magazines_2eceg","ba-relative":"magazines_1wcqO","ba-img":"magazines_gnd5y","ba-absolute":"magazines_xBZ2p","ba-none":"magazines_1Qx3c"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Dashboard/components/MagazineTransfer/styles.scss
// module id = 1040
// module chunks = 1